import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import * as fromActions from './entities-selection.actions';

export const entitiesSelectionStorageKey = (key: string): string =>
    `entities-selection${key}`;

@Injectable()
export class BackEntitiesSelectionEffects
{
    constructor (private actions: Actions)
    { }

    persistSelection = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromActions.BackEntitiesSelectionChanged),
                    tap(({ key, all, entityIds }) =>
                    {
                        try
                        {
                            sessionStorage.setItem(
                                entitiesSelectionStorageKey(key),
                                JSON.stringify({ all, entityIds })
                            );
                        }
                        catch {}
                    })
                ),
        { dispatch: false }
    );
}